import { Text, ThemeIcon } from "@mantine/core";
import clsx from "clsx";
import { forwardRef } from "react";

interface NavBarButtonItemProps {
	label: string;
	icon: React.ReactNode;
	onClick?: () => void;
}

export const NavBarMenuButtonItem = forwardRef<
	HTMLDivElement,
	NavBarButtonItemProps & React.ComponentPropsWithoutRef<"div">
>(({ label, icon, onClick, className, ...rest }, ref) => {
	return (
		<div
			ref={ref}
			className={clsx(
				"border-l-4 border-transparent",
				"hover:bg-surface-hover-subtle",
				"inline-flex h-9 items-center max-w-full min-w-full",
				"px-3 rounded-lg cursor-pointer",
				"group whitespace-nowrap",
				className,
			)}
			onClick={onClick}
			{...rest}
		>
			<ThemeIcon className="mr-2" variant="transparent" size="sm" color="eb04">
				{icon}
			</ThemeIcon>
			<Text
				className="max-w-full font-bold pointer-events-auto select-none grow leading-none text-base sm:text-sm"
				truncate="end"
			>
				{label}
			</Text>
		</div>
	);
});
